const ReplayZone = () => {
  return (
    <div className="replay-zone-outer-container">
      <div className="replay-zone-inner-container">
        <div className="replay-zone-message-container">Replay | Coming Soon...!</div>
      </div>
    </div>
  )
}

export default ReplayZone
